/**
 * contiene la información para el manejo de SGA.
 */
export const defaultSga = () => {
    return {
        categoriasfisicas: [],
        categoriassalud: [],
        categoriasambiental: [],
        categoriasNpeligrosas: [],
        id: null
    };
};

/**
 * contiene la información para el manejo de frases.
 */
export const defaultFrases = () => {
    return {
        frasesh: null,
        frasesp: null,
        edicion: ''
    };
};

/**
 * contiene la información para el manejo de medidas de las etiquetas.
 */
export const defaultMedidas = () => {
    return {
        medidah: [
            4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19
        ],
        medidap: [
            4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19
        ],
        medidah4x6: 6,
        medidap4x6: 6,
        medidah7x10: 7,
        medidap7x10: 7,
        medidah18x10: 9,
        medidap18x10: 9,
        medidah21x18: 14,
        medidap21x18: 14,
        medidasesp: [],
        regla: false,
        fabrFech: false
    };
};

/**
 * contiene la información para el manejo de tipos de etiquetas.
 */
export const tiposEtiquetas = () => {
    return {
        tipos: [
            {text: 'Codigo', value: 0},
            {text: '*', value: 1},
            {text: 'Sin separador', value: 2},
            {text: 'Enter', value: 3},
            {text: '-', value: 4}
        ]
    };
};

export const pictos = () => {
    return {
        homologacion: [],
        clasificacion: []
    };
};

/**
 * Data estructura predeterminada para los pictogramas.
 *
 * @author Fernando Claros
 */
export const defaultDataToPictograms = () => {
    return {
        pictogramsClassification: [],
        pictogramsHomologation: []
    };
};

/**
 * Carga todas las variables declaradas en el proceso.
 */
export default {
    selectedSga: defaultSga(),
    tabs_sga:{
        activo: 0
    },
    seeCHealthEffects:false,
    guardado: false,
    jsonSga: [],
    frasesHSga: [],
    fisicos: [],
    salud: [],
    ambiental: [],
    peligrosas: [],
    Medidas: defaultMedidas(),
    Frases: defaultFrases(),
    idioma: {valor: 'Espanol'},
    idiomas: ['Espanol', 'Ingles', 'Portugues'],
    versiones: [6],
    pictogramas: pictos(),
    version: 6,
    tipo: {valor: ''},
    tipos: tiposEtiquetas(),
    filtro: {
        empresa: ''
    },
    conPictograma: true,
    empresas: [],
    cargando_datos_select: false,
    activar: false,
    visibilidadFrasesSga: false,
    visibilidadSgaCompleto: false,
    componentesVisibles: [],

    // Pictogramas estructura
    pictograms: defaultDataToPictograms(),
    signalWord: {
        visible: false,
        word: ''
    }
};
